import React, { useEffect } from 'react';

import Error from '../Error/Error';
import { recordUnroutedPath } from '../../utils/rum';

/** 404 page that logs the unrouted path to AWS RUM for legacy link detection. */
function NotFound() {
  useEffect(() => {
    const path = window.location.pathname + window.location.search;
    recordUnroutedPath(path);
  }, []);

  return <Error code={404} />;
}

export default NotFound;
